module.exports = __webpack_public_path__ + "static/media/zheng2-4@3x.19d1425b.png";